import { ReactElement, useEffect, useState } from 'react';

interface LazyProps {
  onRunning: Promise<any>;
  onComplete: (result: any) => ReactElement;
}

export enum LazyStatus {
  RUNNING,
}

export function Lazy(props: LazyProps) {
  const [result, setResult] = useState(LazyStatus.RUNNING);

  useEffect(() => {
    let isSubscribed = true;

    props.onRunning.then((result) => {
      if (isSubscribed) {
        setResult(result);
      }
    });

    return () => {
      isSubscribed = false;
    };
  });

  return props.onComplete(result);
}
